import { Sun, Wind, HeartHandshake } from "lucide-react";
import { Reveal, Eyebrow } from "@/components/Reveal";

const VALUES = ["Community", "Creativity", "Patience", "Movement", "Outdoor Living"];

const Emblem = ({ icon: Icon, dark = false }) => (
  <span
    className={`shrink-0 w-14 h-14 rounded-full grid place-items-center border-[3px] ${
      dark ? "bg-navy border-marigold text-marigold" : "bg-marigold border-navy text-navy"
    }`}
  >
    <Icon className="w-6 h-6" />
  </span>
);

const VisionMission = ({ content }) => (
  <section id="vision" className="relative py-24 sm:py-32 bg-paperdeep overflow-x-clip overflow-y-visible" data-testid="vision-section">
    <div className="max-w-7xl mx-auto px-5 sm:px-8">
      <Reveal className="text-center">
        <Eyebrow>Vision &amp; Mission</Eyebrow>
        <h2 className="mt-5 font-display font-bold text-navy text-4xl sm:text-5xl" data-testid="vision-heading">
          Revive. Reconnect. <span className="text-verm">Rise.</span>
        </h2>
      </Reveal>

      <div className="mt-14 grid md:grid-cols-2 gap-8">
        <Reveal>
          <div
            className="h-full bg-paper border-2 border-navy/15 rounded-2xl p-8 sm:p-10 shadow-lg shadow-navy/10 hover:-translate-y-1 hover:shadow-xl transition-all duration-300"
            data-testid="vision-card"
          >
            <div className="flex items-center gap-4">
              <Emblem icon={Sun} />
              <h3 className="font-display font-bold text-navy text-2xl sm:text-3xl" data-testid="vision-card-title">
                {content.vision_title}
              </h3>
            </div>
            <p className="mt-6 font-body text-navy/85 text-base sm:text-lg leading-relaxed" data-testid="vision-card-text">
              {content.vision_text}
            </p>
          </div>
        </Reveal>

        <Reveal delay={0.12}>
          <div
            className="h-full bg-navy rounded-2xl p-8 sm:p-10 shadow-xl shadow-navy/30 hover:-translate-y-1 transition-all duration-300 relative overflow-hidden"
            data-testid="mission-card"
          >
            <div
              className="absolute -right-8 -top-8 w-44 h-44 opacity-10"
              style={{
                backgroundImage:
                  "url(\"data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 40 52'><path d='M20 2 L34 18 L20 34 L6 18 Z' fill='%23f0b52f'/></svg>\")",
                backgroundRepeat: "repeat",
              }}
              aria-hidden="true"
            />
            <div className="flex items-center gap-4">
              <Emblem icon={Wind} dark />
              <h3 className="font-display font-bold text-paper text-2xl sm:text-3xl" data-testid="mission-card-title">
                {content.mission_title}
              </h3>
            </div>
            <p className="mt-6 font-body text-paper/85 text-base sm:text-lg leading-relaxed" data-testid="mission-card-text">
              {content.mission_text}
            </p>
          </div>
        </Reveal>
      </div>

      <Reveal delay={0.15}>
        <div className="mt-12 flex flex-wrap justify-center gap-3" data-testid="values-row">
          {content.values?.length
            ? content.values.map((v) => (
                <span
                  key={v}
                  className="inline-flex items-center gap-2 bg-paper border-2 border-navy/20 text-navy font-body font-semibold px-5 py-2 rounded-full hover:border-verm hover:text-verm transition-colors duration-300"
                >
                  <HeartHandshake className="w-4 h-4 text-verm" />
                  {v}
                </span>
              ))
            : VALUES.map((v) => (
                <span key={v} className="inline-flex items-center gap-2 bg-paper border-2 border-navy/20 text-navy font-body font-semibold px-5 py-2 rounded-full">
                  <HeartHandshake className="w-4 h-4 text-verm" />
                  {v}
                </span>
              ))}
        </div>
      </Reveal>
    </div>
  </section>
);

export default VisionMission;
